import React from "react";

function EulePage() {
  return (
    <iframe
      src="https://www.eeule.de/app/"
      title="text/html"
      width="100%"
      style={{
        border: "none",
        height: "88vh",
      }}
    ></iframe>
  );
}

export default EulePage;
